import { render, staticRenderFns } from "./ManagedFiles.vue?vue&type=template&id=386b93ee"
import script from "./ManagedFiles.vue?vue&type=script&lang=js"
export * from "./ManagedFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports